/**
 * Defines the Type of Affiliate code.
 */
export enum AffiliateTypeEnum {
  FREINDS = "friends",
  COOPERATION = "cooperation",
  OTHER = "other"
}
